function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t\t.st12{display:inline;}\r\n\t\t.st11{fill:#231F20;}\r\n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  className: "recall"
}, /*#__PURE__*/React.createElement("g", {
  className: "st12"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50,100C22.4,100,0,77.6,0,50S22.4,0,50,0c27.6,0,50,22.4,50,50S77.6,100,50,100z M50,3.3 C24.3,3.3,3.3,24.3,3.3,50S24.3,96.7,50,96.7S96.7,75.7,96.7,50S75.7,3.3,50,3.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M50.7,71.9c-1.6,0-3.3-0.2-4.9-0.5l-0.1,0l-0.1,0c-0.8-0.3-1.3-1.1-1.1-2c0.2-0.8,0.9-1.3,1.7-1.3 c0.1,0,0.2,0,0.3,0l0.1,0l0.1,0c1.3,0.3,2.7,0.4,4,0.4c10.2,0,18.5-8.3,18.5-18.5c0-2.7-0.6-5.4-1.8-7.9l-1.7-3.6l-3.5,8.9 c-0.3,0.7-0.9,1.1-1.6,1.1c-0.2,0-0.4,0-0.6-0.1c-0.4-0.2-0.8-0.5-0.9-0.9c-0.2-0.4-0.2-0.9,0-1.3l4.4-11.1 c0.3-0.7,0.9-1.1,1.6-1.1c0.1,0,0.2,0,0.3,0l11.8,1.8c0.5,0.1,0.9,0.3,1.1,0.7c0.3,0.4,0.4,0.8,0.3,1.3 c-0.1,0.8-0.8,1.5-1.7,1.5l0,0c-0.1,0-0.2,0-0.3,0l-7.2-1.1l1.3,2.9c1.3,2.8,1.9,5.9,1.9,9C72.6,62.1,62.8,71.9,50.7,71.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st11",
  d: "M35.9,65c-0.1,0-0.2,0-0.3,0l-11.8-1.8c-0.5-0.1-0.9-0.3-1.1-0.7c-0.3-0.4-0.4-0.8-0.3-1.3 c0.1-0.8,0.8-1.5,1.7-1.5c0.1,0,0.2,0,0.3,0l7.2,1.1L30.2,58c-1.3-2.8-1.9-5.9-1.9-9c0-12.1,9.8-21.9,21.9-21.9 c1.6,0,3.3,0.2,4.9,0.5l0.1,0l0.1,0c0.8,0.3,1.3,1.1,1.1,2c-0.2,0.8-0.9,1.3-1.7,1.3c-0.1,0-0.2,0-0.3,0l-0.1,0l-0.1,0 c-1.3-0.3-2.7-0.4-4-0.4C40,30.5,31.7,38.8,31.7,49c0,2.7,0.6,5.4,1.8,7.9l1.7,3.6l3.5-8.9c0.3-0.7,0.9-1.1,1.6-1.1 c0.2,0,0.4,0,0.6,0.1c0.4,0.2,0.8,0.5,0.9,0.9c0.2,0.4,0.2,0.9,0,1.3l-4.4,11.1C37.2,64.6,36.6,65,35.9,65L35.9,65z"
})))));

var SvgRecall = function SvgRecall(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRecall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recall.037ffb33.svg";
export { ForwardRef as ReactComponent };